export default __webpack_public_path__ + "static/oeko-tex-organic-cotton-b5e0099af2d4bd4e4322afead009150a.png";